import { useState, useEffect } from "react";
// India (Asia/Kolkata) real-time helpers — single source of truth for "today" in the UI.
export const istNow = () => new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const istToday = () => ymd(istNow());
export const istNowMinutes = () => { const n = istNow(); return n.getHours() * 60 + n.getMinutes(); };

// Re-renders with the new date the moment IST crosses midnight (checked every 20s).
export const useIstDay = () => {
  const [day, setDay] = useState(istToday());
  useEffect(() => {
    const t = setInterval(() => { const d = istToday(); if (d !== day) setDay(d); }, 20000);
    return () => clearInterval(t);
  }, [day]);
  return day;
};
